import { loadDynamicRange } from '@inter-ikea-core/ipex-brygga-range-loader';
const getChangePackage = async () => {
    const params = new URLSearchParams(window.location.search);
    const changePackageParam = params.get('brygga');
    return changePackageParam;
};
const isDevelopment = () => {
    const baseUrl = window.location.hostname;
    if (baseUrl.includes('cte.ikeadt') || baseUrl.includes('localhost')) {
        return true;
    }
    return false;
};
export const fetchBryggaData = async (productCatalog, experienceName) => {
    const changePackageParam = await getChangePackage();
    if (isDevelopment() && changePackageParam) {
        const changePackage = changePackageParam === 'main' ? '' : changePackageParam;
        try {
            const rangeLoaderResults = await loadDynamicRange(experienceName, changePackage, 'prod');
            const resultForCatalog = rangeLoaderResults.find(result => JSON.parse(result.catalog).range === productCatalog.catalog.range);
            if (resultForCatalog) {
                const { catalog, template } = resultForCatalog;
                return {
                    catalog: JSON.parse(catalog),
                    template: JSON.parse(template)
                };
            }
            else {
                const { catalog, template } = productCatalog;
                return {
                    catalog,
                    template
                };
            }
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.warn('Error loading range from brygga', error);
            return null;
        }
    }
};
//# sourceMappingURL=fetchBryggaData.js.map